import { useButtonClick } from '@emico-hooks/buttons'
import { testId } from '@emico-utils/datalayer'
import { overrideOptional } from '@emico-utils/overrides'
import styled from '@emotion/styled'
import { ComponentProps } from 'react'
import { AriaButtonProps } from 'react-aria'

import { Button } from './Button'

const StyledButton = styled(Button)<Props>`
  all: unset;

  &:focus {
    outline: none;
  }
`

type Props = Pick<
  ComponentProps<typeof Button>,
  'analyticsName' | 'analyticsContext' | 'onPress' | 'children' | 'as'
> &
  AriaButtonProps

export const ButtonUnstyled = overrideOptional(
  ({ analyticsName, analyticsContext, onPress, ...other }: Props) => {
    const handleClick = useButtonClick(analyticsName, analyticsContext, onPress)

    return (
      <StyledButton
        onPress={handleClick}
        data-testid={testId(analyticsName, analyticsContext)}
        {...other}
      />
    )
  },
)
